import { createTheme } from '@mui/material/styles';
import { brand } from './config';

export const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: { main: brand.colors.primary },
        secondary: { main: brand.colors.secondary },
        background: {
            default: brand.colors.background,
            paper: brand.colors.surface,
        },
    },
    typography: {
        fontFamily: "'Karla', sans-serif",
        button: {
            textTransform: 'none',
            fontWeight: 700,
        },
    },
    shape: {
        borderRadius: 14,
    },
    components: {
        MuiTextField: {
            defaultProps: {
                variant: 'filled',
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
        },
    },
});
